module.exports = __webpack_public_path__ + "static/media/Logo1.52ce88b1.png";